<div class="out" #outComponent>
  <!-- <assets-header *ngIf="!bSmall" [bShowSigners]="false" class="hdr"> </assets-header> -->
  <div #container class="container" [style.height.px]="container_height" [style.top.px]="container_top" [style.width.px]="container_width" [style.left.px]="container_left">
    <img #img class="fit" *ngIf="img_src" [src]="img_src" (load)="onImageLoad($event)">
    <img-slide *ngIf="bShowSlide" class="slide" [asset]="_asset" (indexChange)="select($event,true)"> </img-slide>
  </div>

  <k-paginator *ngIf="num_imgs>1" class="paginator" [pages]="num_imgs" (indexChange)="selImage($event)"></k-paginator>
</div>
